module.exports = __webpack_public_path__ + "static/media/valor2.b07ffaec.png";